import { PeriodTypeEnum } from '@/enums/period-type';
import { RepaymentModel } from '@/po/ProductResult';
import type { AdjustQuotaType } from '@/dict/quotaIncrease-type';
import { PreCreditUserSourceEnums } from '@/enums/home-type';
import { EquitySelectedEnum, PricingTypeEnum } from '@/enums/rights';
import { RightPackageTypeEnum } from '../rights/types';


/** 渠道是否可用  1可用、0不可用 */
export enum ChannelDisableEnum {
  /** 可用 */
  AVAILABLE = 1,
  /** 不可用 */
  NOT_AVAILABLE = 0
}

/** 渠道是否可用对应具体类型
 * disabledStatus目前除了9，返回其他任何都代表不可用
 * 等同于disabledStatus = 9 ，disabled的值一定是1、disabledStatus != 9 ，disabled的值一定是0
 */
export enum ChannelAvailableEnum {
  /**
   * 1 准入不通过
   * */
  NO_ALLOW = 1,
  /**
   * 2 额度过期
   * */
  AMOUNT_OVERDUE = 2,
  /**
   * 3 维护中
   * */
  UNDER_MAINTENANCE = 3,
  /**
   * 4 可用额度<渠道最小可用额度>
   * */
  AVAILABLE_CREDIT = 4,
  /**
   * 5 单笔单批/兜底
   * */
  SINGLE_BATCH = 5,
  /**
   * 6 授信冻结
   * */
  CREDIT_FROZEN = 6,
  /**
   * 7 渠道资金不足
   * */
  INSUFFICIENT_FUNDS = 7,
  /**
   * 8 全局本地初筛拦截
   * */
  GLOBALLOCALINTERCEPTION = 8,
  /**
   * 9 可用
   * */
  CURRENTAVAILABLE = 9
}

// Available Credit

export enum ChannelCreditStatusEnum {
  // 等待中
  PENDING = 'PENDING',
  // 授信中
  SUBMITTING = 'SUBMITTING',
  // 授信成功
  SUCCEEDED = 'SUCCEEDED',
  // 授信拒绝
  REJECT = 'REJECT',
  // 授信失败
  FAILED = 'FAILED',
  // 授信异常
  EXCEPTION = 'EXCEPTION',
  // 授信失效
  OVERDUE = 'OVERDUE',
  // 授信冻结
  FROZEN = 'FROZEN',
}

/** 渠道提现要求 */
export enum ChannelApplyLimitEnum {
  /** 普通渠道，不做限制 */
  NO_LIMIT = 'NO_LIMIT',
  /** 只能体现一次 */
  ONCE_LIMIT = 'ONCE_LIMIT',
  /** 必须一次提现全部金额 */
  ALL_LIMIT = 'ALL_LIMIT',
  /** 应放款机构的要求，本产品建议只绑定一张银行卡 */
  BIND_CARD_ONCE = 'BIND_CARD_ONCE',
  /** 本渠道需还清借款后才能继续提现，建议您取出全部额度 */
  LOAN_AFTER_PAYMENT = 'LOAN_AFTER_PAYMENT',
}

/** 提现申请模式 */
export enum RouteMarketEnum {
  /** 串行 */
  SERIAL = 'serial',
  /** 单个模式 */
  ORIGINAL = 'original',
}

/** 提现模式枚举 */
export enum LoanModelEnum {
  /** 快速提现 */
  QUICK = 'quick',
  /** 常规提现 */
  NORMAL = 'normal',
}

/** 可提现的渠道列表场景值 */
export enum pageSceneEnum {
  /** 提现页 */
  APPLY_PAGE = 'applyPage',
}

/** 降价人群标签枚举 */
export enum LoanRateEnum {
   /** 无降价场景 */
   LOAN_RATE_NONE_SCENE = '0',
  /** 降价人群 */
  LOAN_RATE_24_ZY_USR = '1',
}

export interface AlipayPO {
  serialNumber: string;
  signUrl: string;
}

/**  可提现的单个渠道信息 */
export interface ApplyChannelData {
  /** 申请时间 */
  applyDate: string;
  /** 可用额度 */
  availableAmount: string;
  /** 授信额度 */
  creditAmount: string;
  /** 额度过期时间 */
  creditExpiryDate: string;
  /** 额度状态 */
  creditStatus: ChannelCreditStatusEnum;
  /** 是否可以提现（额度冻结、过期等不能提现） */
  enableWithDraw: boolean;
  /** 提现限制 */
  applyLimit: ChannelApplyLimitEnum;
  /** 产品信息 */
  productId: string;
  /** 产品名称 */
  productName: string;
  /** 产品图标 */
  productIcon: string;
  /** 最小提现金额 */
  minLoanAmount: number;
  /** 1 可用 0 不可用 */
  disabled: ChannelDisableEnum;
  /** 不可用提示语 */
  alertMsg: string;
  /** 不可用状态， 1准入不通过，2：额度过期，3：维护中，4：可用额度<渠道最小可用额度，5：单笔单批/兜底，6:授信冻结，9：可用 */
  disabledStatus: ChannelAvailableEnum;
  /**  授信流水号 ID */
  creditApplyId: string;
  /** 标记外部来源id（流量外采用） */
  sourceId: string;
  /** capitalCode 资金 code 自营 B 一个渠道 多个资方场景 */
  capitalCode?: string;
  /** 资金类型，用来标识当前资方的资金类型（24、36） */
  rateType?: RateTypeEnum;
  /** 提现申请模式 */
  routeMarket: RouteMarketEnum;
  /** 额度调整 */
  adjustQuota?: AdjustQuotaType;
  /** 自营授信续期提醒 */
  creditExpireRenewalTip?: string;
  /** 当前提现的产品是否需要购买权益 */
  needRight?: boolean;
  /** 当前提现产品需要购买的权益包类型 */
  packageType?: RightPackageTypeEnum;
  /** 资金方的列表(仅自营有) */
  capitalList: ProductCapitalItem[];
  /** 极益承接资产渠道ID，只有24+权益单通道场景才会返回这个字段
   * 需求方案：https://hellobike.yuque.com/gpxxgb/oyyz8n/tnivcnbk9nrook6h
   */
  rightLight36ProductId?: string;
  /** 普通通道承接未授信渠道id
   * 需求方案：https://hellobike.yuque.com/gpxxgb/oyyz8n/bstne67wr8wgd5d2
   */
  rightLightUncreditedProductId?: string;
  fundRouteResponseId?: string;
  /** 默认选择的资方idx，服务端默认返回0 */
  defaultSelectCapitalIndex: number | undefined;
  /** 自营新老客标识 true 新客、false 老客，默认值 true */
  newCustomerFlag?: boolean;
  /** 是否-预授信 */
  preCredit: boolean;
  /** 预授信用户来源 */
  preCreditUserSource: PreCreditUserSourceEnums,
  /** 降价人群标签(可为空) 0：无场景 1：降价人群 */
  userLoanRate24ZyUsr?: LoanRateEnum;
  /** 用户标签 */
  userTag?: string;
  /** 是否是第一个单行展示 */
  firstRowDisplay?: boolean;
  /** 营销推荐文案 */
  marketingDesc?: string;
  /** 是否展示选择挽留弹窗，true 展示，false 不展示 */
  showPositivePopWindow?: boolean;
  /** 是否展示期数切换 挽留弹窗，true 展示，false 不展示 */
  showPeriodRecommend?: boolean;
  /** 是否支持营销额度，true 是，false 否 */
  supportMarketingAmount?: boolean;
  /** 是否ocr后置提现 */
  ocrAfterLoan: boolean;
  /** 是否属于部分放款渠道，true 是，false 否 */
  loanPartTag?: boolean;
}

export interface ProductCapitalDetail {
  /** 资方名称 */
  capitalName: string,
  /** 资方code */
  capitalCode: string
}

export enum RateTypeEnum {
  CAPITAL_TYPE_20 = '20',
  CAPITAL_TYPE_24 = '24',
  CAPITAL_TYPE_36 = '36',
}

export interface ProductCapitalItem {
  /** 产品id */
  productId: string;
  /** 是否需要权益购买："true"需要，"false"不需要，非自营B该字段不出现，其他为错误信息 */
  needRight: boolean;
  /** 自营提现申请模式，自营有资方时，存在枚举值：serial 串行，original 单个模式，无资方改字段不出现 */
  routeMarket: RouteMarketEnum;
  /** 资金类型，用来标识当前资方的资金类型 */
  rateType?: RateTypeEnum;
  /** 串行模式，资方列表 */
  capitalListDetail?: ProductCapitalDetail[];
  /** 多资方code以"_"拼接而成的字符串 */
  capitalCode?: string;
  /** 是否需要购买超级会员："true"需要，"false"不需要，非自营B该字段不出现，其他为错误信息 */
  showSuperMember?: boolean;
  /** 权益包类型 */
  packageType?: RightPackageTypeEnum;
  /** 是否属于部分放款渠道，true 是，false 否 */
  loanPartTag?: boolean;
}

export interface PeriodRuleItemData {
  // 期限、利率、单位
  period: number | string;
  periodRate: number | string;
  periodUnit: PeriodTypeEnum;
  rateUnit: PeriodTypeEnum;
}

export interface PeriodRuleData {
  min: number;
  max: number;
  periodRule: PeriodRuleItemData[];
  // 后端接口可能存在的错误传参
  preriodRule?: PeriodRuleItemData[];
}

export interface ProductUserData {
  userId: string;
  // 剩余可用金额
  availableAmount: number;
  // 不包含临时额度的剩余可用金额
  limitAvailableAmount: number;
  // 支付宝账号（部分渠道存在该字段，比如：趣店）
  alipayAccount: string;
  // 上次成功提现所绑定的银行预留手机号、名称、卡号，首次提现的情况不会出现这些字段
  bankName: string;
  bankNo: string;
  bankMobile: string;
  bankIconUrl: string;
  userBankCardId: string;
}

export interface ProductInfoData {
  productId: string;
  productName: string;
  productIconUrl: string;
  /** 期限列表、单位以及期限对应的利率，根据限制的最小最大金额动态匹配可以选择的期限列表 */
  periodRules: PeriodRuleData[];
  /** 还款方式 */
  repaymentModel: RepaymentModel[];
  /** 是否支持按期还款，true 支持，默认不返回这个字段，现在不返回true，后面删除相关代码 */
  repayOnSchedule?: boolean;
  /** 最小借款金额 */
  minApplyAmount: number;
  /** 满额提现的情况下：借款金额的最小单位，如：100 */
  applyAmountStep: number;
  /** 借款金额的最小单位，如：100，用于前端校验当前的提现金额  自营B提现最小步长 */
  checkAmountStep: number;
  /** 提现超次利率 */
  repaymentRate: number;
  /** 单次提现最大金额 */
  everyMaxAmount: number;
  /** 计息方式描述 */
  calcMethod: string;
  /** 当前提现渠道或者资方下方是否展示提示文案（国美渠道添加） */
  notes?: string;
}

// 申请提现的产品信息
export interface ApplyProductData {
  // 用户在渠道下相关的用户信息
  userCredit: ProductUserData;
  // 产品信息
  productInfo: ProductInfoData;
  // 是否需要补充渠道资料
  productSupplyFlag: boolean;
}

// 获取申请产品信息接口入参
export interface GetApplyProductParams {
  /** 产品ID */
  productId: string;
  /** 资方 code 集合，多个时候 用下划线_隔开 70001_70002 */
  capitalCode?: string;
  /** 是否预授信召回挽留流程 */
  recallPreCredit?: boolean;
  /** 资金路由Id */
  fundRouteResponseId?: string;
}

export interface CalcPlanList {
  // 本金
  amount: number;
  // 到期日
  dueDate: string;
  // 利息加息费
  fee: number;
  // 费用
  feeOnly: number;
  // 利息
  interest: number;
  // 期限
  period: number;
  // 减免金额
  reductionAmount: number;
  // 应还金额
  shouldPayAmount: number;
  // 担保费
  addChargeValue1: number;
  // 应还逾期违约金
  addChargeValue2: number;
  chargeValue1: number;
  chargeValue2: number;
  // 服务费
  servicesFee: number;
  serviceFee: number;
  // 保费
  insuranceFee: number;
  // 息费
  interestFees: number;
  /** 原始担保费 */
  guaranteeFeeFirst?: number,
  /** 剩余应还担保咨询费 */
  guaranteeConsultingFee?: number,
  /** 原始担保咨询费 */
  guaranteeConsultingFeeFirst?: number,
  /** 债务咨询服务费 */
  debtConsultingFee?: number,
  /** bonusAmount */
  bonusAmount?: number,
  /** 优惠券返回金额 */
  couponAmount?: string;
  /** 优惠券金额描述 */
  couponAmountDesc?: string,
}

export interface FundListDataType extends CalcPlanListData {
  /** 资方Code */
  fundCode: string,
  /** 资方名称 */
  fundName: string,
}

// 借款试算结果
export interface CalcPlanListData {
  // LPR浮动利率
  lprFloatRate: string;
  // LPR发布定价
  lprIssueMaprice: string;
  // LPR定价发布日期
  lprMapriceIssueDt: string;
  // 还款金额返回类型：1、本金+利息 2、月供金额 默认：1
  repayAmountType: number;
  // 提前结清费用
  settleFee: number;
  // 提前结清手续费最高金额
  settleFeeMax: number;
  // 提前结清费用比例
  settleFeeRate: number;
  // 每期应还金额（包含借款关联费用和债务咨询服务费）
  shouldPayAmount: number;
  /** 每期应还金额（仅包含借款关联费用） */
  periodLoanRelatedAmount?: number;
  /** 借款关联费用总额（不含债务咨询服务费） */
  loanRelatedAmount?: string;
  /** 债务咨询服务费总额 */
  debtConsultingTotalAmount?: string;
  /** AMC标识 */
  amcFlag: boolean;
  // 试算还款计划列表
  loanCalcList: CalcPlanList[];
  // 是否需要先补充资料才能试算，（中原渠道 现已不合作，无流量了）
  needSupplyMaterials?: boolean;
  // 针对部分渠道需要展示利率信息：利率类型、利率大小（小数制）
  rateType?: InterestRateTypeEnum;
  rateValue: number;
  // 资金方
  lender: string;
  // 借款试算结果状态: SUCCESS成功 FAILED失败
  calcResult: string;
  // 借款试算结果明细
  calcMsg: string
  // 对客展示失败编码
  userCalcCode?: number;
  // 借款试算结果展示文案
  userCalcMsg: string;
  // 是否需要投保
  insure: boolean;
  // 投保地址
  insureForwardUrl: string;
  // 试算流水号
  trialFlowNo: string;
  // 备注, 放在结清规则下面
  notes: string;
  /** 多资方列表 */
  fundList?: FundListDataType[];
  /** 保险费率 */
  insuranceRate?: string;
  /** 还款计划，灰色小字：仅供参考，实际还款计划根据匹配的资金方决定 */
  indexNotes?: string;
  /** 按期还款 奖励红包总金额 */
  bonusTotalAmount?: number;
  /** 按期还款利率 小数 */
  bonusRateValue?: number;
  /** 提前结清规则 */
  settleFeeRule?: string;
  /** 轻资产返回的用户权益定价类型 */
  pricingType?: PricingTypeEnum;
  /** 优惠券名称信息 */
  couponName?: string,
  /** 优惠券使用说明 */
  couponDesc?: string,
  /** 优惠券优惠金额 */
  couponDiscountAmount?: number,
  /** 总优惠金额 */
  totalDiscountAmount?: number,
  /** 优惠券折扣率 */
  couponDiscountRate?: number,
}

/** 计算折扣状态枚举 */
export enum CalcDiscountStatusEnum {
  /** 加载中 */
  LOADING = 'LOADING',
  /** 可计算折扣金额 */
  CALC_DISCOUNT_AMOUNT = 'CALC_DISCOUNT_AMOUNT',
  /** 不可计算折扣金额 */
  NO_CALC_DISCOUNT_AMOUNT = 'NO_CALC_DISCOUNT_AMOUNT',
}

// 借款用途
export interface LoanUsageOption {
  name: string;
  code: string;
}

// 远程协议
export interface RemoteContract {
  // 是否强制阅读 0 / 1
  forceRead: string;
  name: string;
  token: string;
  url: string;
  isThirdUrl?: boolean;
  // 路由渠道征信，后端在查询到征信协议时获取到并插入到征信协议信息中
  creditRouteChannel?: string,
}

// 申请下单时的检测结果
export interface SubmitApplyCheckResult {
  // 支付宝账号check,true代表不需要check
  alipayAccontCheck: boolean;
  // 支付宝代扣check,true代表不需要check
  alipayWithholdCheck: boolean;
  // 银行卡check,true代表不需要check
  bankCardCheck: boolean;
  // 下单checkId
  checkId: string;
  // 活体check,true代表不需要check
  faceCheck: boolean;
  // 0:下单检测成功,1:下单检测拒绝
  result: number;
  // 需要发送短信,true代表不需要check
  sms: boolean;
  // 前置校验用户信息true代表不需要check
  userInfo: boolean;
  // 错误信息
  errMsg: string;
  // 短信验证失败的标志 1---短信验证码错误
  smsCheckError: string;
  // 身份证过期上传校验 true代表不需要重新上传，false需要重新上传
  idCardExpiredCheck: boolean
  // 度小满-交易鉴权 true 不需要 false 需要
  wait: boolean;
  // 是否获取新的提现协议
  contractAdd: boolean,
  // 协议类型
  contractType: string
  /**
   * 小象提现渠道资方要求短验
  */
  postPositionSms: boolean,
  /** 是否需要通联二次绑卡 */
  allinPayCheck?: boolean,
}

// 申请提现返回结果
export interface SubmitApplyResultData {
  // 订单id
  loanOrderId: string;
  // 放款流水id
  repaymentOrderMessageId: string;
  // 下单时检测的结果
  applyOrderCheckVo: SubmitApplyCheckResult;
  // 度小满-借款后第一次等待,true需要，false不需要
  loanWait: boolean;
  /** 权益类型和生效中搭配 使用 */
  packageType?: RightPackageTypeEnum;
  /** 是否需要购买权益（臻快卡）
   * 在提现后置流程，与臻享卡有区别
   */
  needBuyEquity?: boolean;
  /** 已购权益生效中标识（臻快卡新增)
   * true: 有生效中权益，
   * false: 没有生效中权益 */
  equityEffect?: boolean;

  /** 是否24资方权益卡单订单，true 是，false 否，命中跳转权益卡单页 */
  orderStuck?: boolean,
}

// 短信验证码验证结果
export interface SmsConfirmResult {
  loanOrderId: string;
  // 短信验证结果提示信息
  msg: string;
  // 放款流水
  repaymentOrderMessageId: string;
  // 短信验证是否通过：true / false
  result: boolean;
}

// 验证银行卡是否可用
export interface CheckBankCardCanUse {
  cardNo?: string;
  isBind: boolean;
  productId: number;
}

// 新银河-查询签约
export interface AlipayCheckStatus {
  alipayUserId: string;
  invalidTime: string;
  protocolNo: string;
  signState: string;
  signTime: string;
  transSerials: string;
  validTime: string;
}

// 新银河-签约申请
export interface SignAlipay {
  params: string;
}

export interface OrderQueryRealTime {
  /**
   * 是否需要调用合同协议
  */
  contractAdd: boolean,
  /**
   * 渠道订单号
  */
  outOrderNo: string,
  /**
   * 合同类型
  */
  contractType: string,
}

export interface OrderCheck {
  /**
   * 未完成订单金额
  */
  amount: number,
  /**
   * 是否需要弹窗true/false
  */
  popWindow: boolean,
  /**
   * 订单号
  */
  loanOrderId: string,
  /**
   * 合同类型
  */
  contractType: string,
}

export interface getLoanContractParams {
  /** 商品ID  */
  commodityId: string;
  /** 借款金额单位:分 */
  amount: string;
  /** 期数，如果是获取借款合同时，必须传 */
  period: string;
  /** 借款用途 */
  loanUsage: string;
  /** 银行卡号Id */
  bankCardId: string;
  /** 还款方式 */
  repaymentModelName?: string;
  /** 业务订单ID */
  orderId: string;
  /** 合同类型 */
  type: string;
  /** 试算流水号 */
  trialFlowNo?: string;
  /** 资方 code 自营 B 多资方 */
  capitalCode?: string;
  /** 是否需要展示通联绑卡协议 */
  showAllinPayContract: boolean;
  /** 权益选择 */
  equitySelected?: EquitySelectedEnum;
  /** 权益定价类型 */
  pricingType?: PricingTypeEnum;
  /** 扩展字段，透传给后端 */
  extendObj?: Record<string, unknown>;
}

export enum AccountType {
  BANK = '01',
}

export enum CardBindTypeEnum {
  ALIPAY = 'ALIPAY',
  BANK = 'BANK',
}
export interface PayType {
  payType: CardBindTypeEnum
}

/** equityPath 0是主动购买，提现流程未购买权益 1是划扣-提现购买权益 */
export enum EquityPathType {
  NOT_NEED_RIGHT = 2,
  BUY_RIGHTS = 1,
  NORMAL = 0,
  NONE = '',
}

export interface AllinpayCheckRequestType {
  productId: string;
  bankCardId: string;
  equityTick: boolean;
  processApplyId?: string;
  /** 是否处于倒计时中，此时不需要二次发起验证码发送 */
  needBindCardApply?: boolean;
  /** 用户定价标签 */
  pricingType?: PricingTypeEnum;
  /** 主要用于透传相关埋点数据 */
  tqParams?: {
   capitalCode: string,
   packageType?: RightPackageTypeEnum,
  }
}

/**  */
export interface AllinpayCheckStatus {
  /** 是否需要通联绑卡短验, true:需要通联绑卡；false:不需要通联绑卡 */
  result: string;
  /** 绑卡申请ID, result为true, 绑卡申请ID不为空 */
  applyId: string;
  /** 绑卡流程申请ID, 重新发送验证码场景需要使用 */
  processApplyId: string;
  /** 产品Id */
  productId: string;
}

export interface AllinpayAuthRequestType {
  /** 产品ID */
  productId: string;
  /** 银行卡记录ID */
  bankCardId: string;
  /** 绑卡申请ID */
  applyId: string;
  /** 绑卡流程申请ID */
  processApplyId?: string;
  /** 短信验证码 */
  smsCode: string;
}

export enum AuthTypeEnum {
  /** 验证通过 */
  AUTH = 1,
  /** 超过验证次数 */
  OVER_LIMIT_PASS = 2
}

/** 利息率类型枚举 */
export enum InterestRateTypeEnum {
  /** 年 */
  YEAR = 'YEAR',
  /** 月 */
  MONTH = 'MONTH',
  /** 日 */
  DAY = 'DAY',
  /** 空值 */
  NONE = '',
}

export interface AllinpayAuthStatus {
  /** 是否通过 true:需要通联绑卡；false:不需要通联绑卡 */
  pass: boolean;
  /** 绑卡申请校验场景 */
  passScene: AuthTypeEnum;
}

export interface LoanApplyMarketReqType {
  /** 权益类型 */
  packageType?: RightPackageTypeEnum;
  /** 权益id */
  packageId?: string;
  /** 权益下单来源 */
  packageFrom?: string;
  /** 权益下单价格,臻享卡特有，主要作用于用户命中权益豁免的情况下，后端用于下单校验 */
  expectPrice?: number;
  /** 权益path计算值，臻享卡特有，  equityPath 0是主动购买，提现流程未购买权益 1是划扣-提现购买权益， 2 无需购买 */
  equityPath?: EquityPathType;
  /** 权益订单降价人群标签，目前只有自营2+0超会有
   * @remark 需求：http://wiki.hellobike.com/pages/viewpage.action?pageId=395717504
  */
  userLoanRate24ZyUsr?: LoanRateEnum;
  /** 权益定价类型 */
  pricingType?: PricingTypeEnum;
}


export interface getRepayPlansParams {
  amount: number;
  period: number;
  productId: string;
  couponId: string;
  repayType: string;
  bankCardId: string;
  /** capitalCode 资方code */
  capitalCode?: string;
  /** 渠道优惠券 id */
  externalCouponId?: string;
  repayOnSchedule?: boolean;
  /** 用户是否需要购买权益，轻资产24+权益时根据用户是否展示权益购买以及是否勾选权益购买
   * @remark 技术方案：https://hellobike.yuque.com/yxr77w/oyyz8n/ag7wgav9obgoqmft
   * @value true, 勾选购买权益； false为不购买
   */
  equitySelected?: EquitySelectedEnum;
  /** 新增version字段用来标识版本，用于区分是否支持线上24+权相关的场景
   * @remark 前端技术方案：https://hellobike.yuque.com/yxr77w/oyyz8n/ag7wgav9obgoqmft
   * @remark 资金侧试算接口默认逻辑详见：https://hellobike.yuque.com/yxr77w/rwg8o2/aizbkzh1ixgzumig
   * @value 1.0.0
  */
  bizVersion?: string;
  /** 是否需要计算优惠券折扣率，true 是，false 否 */
  calcCouponDiscountRate?: boolean;
  /** 资金路由响应ID，与提现申请保持一致 */
  fundRouteResponseId?: string;
}


export interface QuoteLimitRequestType{
  productId: string;
  capitalCode: string;
  capitalType: string;
}

/** 用户场景 */
export enum UserSceneEnum {
  /** 常规 */
  NORMAL = 'normal',
  /** 零用钱 */
  POCKET_MONEY = 'pocketMoney',
}
